module.exports = __webpack_public_path__ + "img/og-image_pocket_en.51c3acd.jpg";